<template>
  <div class="flex-center position-ref full-height">
    <div class="content">
      <Loading :loading="loading"></Loading>
      <img src="/assets/logos/fnlenglish.png" alt="" />
      <h3 v-if="this.$route.query.sso && !error">Lütfen bekleyiniz, ilgili platforma yönlendiriliyorsunuz.</h3>
      <SsoError v-if="error" :message="error"></SsoError>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import SsoError from "@/components/SsoError";
import axios from "axios";
import { isJwtSso } from "@/utils/ssoJwt";

export default {
  name: "FNLEnglish",
  components: {
    Loading,
    SsoError
  },
  data() {
    return {
      loading: false,
      ssoJwt: null,
      resolvedUsername: null,
      error: null,
    }
  },
  beforeMount() {
    const query = this.$route.query;
    if (query.sso && isJwtSso(query.sso)) {
      this.loading = true;
      // Çözümleme (imza doğrulaması OLMADAN) ve okul eşleştirmesi (branchId -> UES
      // school_id, artık burada sabit 63 değil) artık backend'de: AkbimJwtSsoService.
      this.ssoJwt = query.sso;
      this.ueslmsCheckUser();
    } else if (query.sso) {
      console.error('FNL English SSO: beklenmeyen format (JWT değil).');
    }
  },
  methods: {
    fail(message) {
      this.loading = false;
      this.error = message;
      console.log('FNL English SSO:', message);
    },

    ueslmsCheckUser() {
      axios.post('https://www.ueslms.com/api/v2/fnlenglish/user/check', {sso_jwt: this.ssoJwt})
      // axios.post('https://ueslms.test/api/v2/fnlenglish/user/check', {sso_jwt: this.ssoJwt})
          .then(response => {
            if (response.data.success) {
              this.resolvedUsername = response.data.user.username;
              this.goFNLEnglish()
            } else if (response.data.message) {
              // success:false + message → örn. lisans/yetki reddi. Kullanıcı henüz
              // yok diye create'e düşmek yerine reddi doğrudan gösteriyoruz, çünkü
              // create de aynı kontrolden geçip aynı sebeple reddedilecek.
              this.fail(response.data.message)
            } else {
              this.ueslmsCreate()
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    ueslmsCreate() {
      axios.post('https://www.ueslms.com/api/v2/fnlenglish/user/create', {sso_jwt: this.ssoJwt})
      // axios.post('https://ueslms.test/api/v2/fnlenglish/user/create', {sso_jwt: this.ssoJwt})
          .then(response => {
            if (response.data.success) {
              this.resolvedUsername = response.data.user.username;
              this.goFNLEnglish()
            } else {
              this.fail(response.data.message || 'Kullanıcı oluşturulamadı. Lütfen tekrar deneyin.')
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    async goFNLEnglish() {
      const password = '123456'; // akbim'den fnlenglish'e sadece öğrenci sso gelebilir

      location.href = "https://www.fnlenglish.com/#/?username=" + btoa(this.resolvedUsername) + "&password=" + btoa(password);
    },

  }
}
</script>
